import React from 'react';

import ActivityIndicator from '~/UI/ActivityIndicator/ActivityIndicator';
import Loadable from 'react-loadable';

const LoadingSpinner: React.FC<Record<never, never>> = () => <ActivityIndicator />;

const LoadablePriceChart = Loadable({
	loader: () => import(/* webpackChunkName: "price-chart", webpackPrefetch: true */ './PriceChart'),
	loading: LoadingSpinner,
});

LoadablePriceChart.displayName = 'ProductPriceChart.LoadablePriceChart';

export default LoadablePriceChart;
